// 篮球 联赛 CBA
export default {
  data() {
    return {
      containerFullClassName: 'containerFull_basketball_CBA',
      defaultPath: ['basketball', 'CBA', 'schedule'],
      axiosBaseUrl: '/bkbleague',
      sportCompetitionType: 'basketballLeague_CBA', //暂时不加具体中网|汤尤杯这种赛事区别，如果需要后面补字段即可【tennis_chinaOpen,badminton_thomasAndUber, compreSportsMeet_ASG】
    }
  },
}
